import React from 'react';
import { FDSplitText } from '@facet-wealth/design';
import PropTypes from 'prop-types';

export const OtherOptions = ({ resource, relationships }) => {
  // If any one relationship exists, then show the split text
  const show = relationships.reduce((acc, curr) => {
    return acc || resource.withRelationship(curr, () => true, () => false);
  }, false);

  if (!show) {
    return null;
  }

  return (
    <FDSplitText value={'Or'} />
  );
};

OtherOptions.propTypes = {
  resource: PropTypes.object.isRequired,
  relationships: PropTypes.arrayOf(PropTypes.string).isRequired,
};
